import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from '../ui/CTAButton';
export function SolutionSection() {
  return <section className="py-10 md:py-14 px-4 bg-white text-center" data-id="element-183">
      <div className="max-w-3xl mx-auto" data-id="element-184">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-185">
          <div className="inline-block bg-green-100 text-green-800 font-bold px-4 py-1.5 rounded-full mb-4 text-base" data-id="element-186">
            ✅ LA SOLUCIÓN
          </div>

          <h2 className="text-4xl md:text-6xl font-extrabold text-gray-900 mb-4" data-id="element-187">
            Adelgaza con Airfryer
          </h2>

          <p className="text-lg md:text-xl text-gray-700 mb-5 font-medium" data-id="element-188">
            Un sistema diseñado para que puedas:
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-3 text-left max-w-2xl mx-auto mb-8" data-id="element-189">
            <div className="bg-gray-50 p-3 rounded-lg border border-gray-100 flex items-center shadow-sm" data-id="element-190">
              <span className="text-green-500 text-xl mr-3" data-id="element-191">✔</span>
              <span className="font-bold text-gray-800" data-id="element-192">cocinar rápido</span>
            </div>
            <div className="bg-gray-50 p-3 rounded-lg border border-gray-100 flex items-center shadow-sm" data-id="element-193">
              <span className="text-green-500 text-xl mr-3" data-id="element-194">✔</span>
              <span className="font-bold text-gray-800" data-id="element-195">
                reducir calorías sin perder sabor
              </span>
            </div>
            <div className="bg-gray-50 p-3 rounded-lg border border-gray-100 flex items-center shadow-sm" data-id="element-196">
              <span className="text-green-500 text-xl mr-3" data-id="element-197">✔</span>
              <span className="font-bold text-gray-800" data-id="element-198">
                organizar tus comidas
              </span>
            </div>
            <div className="bg-gray-50 p-3 rounded-lg border border-gray-100 flex items-center shadow-sm" data-id="element-199">
              <span className="text-green-500 text-xl mr-3" data-id="element-200">✔</span>
              <span className="font-bold text-gray-800" data-id="element-201">
                mantener hábitos sostenibles
              </span>
            </div>
          </div>

          <p className="text-lg text-gray-600 mb-3" data-id="element-202">
            Todo utilizando una herramienta que ya millones de personas tienen
            en casa:
          </p>

          <p className="text-4xl md:text-5xl font-black text-red-600 italic mb-6 drop-shadow-sm" data-id="element-203">
            la Airfryer
          </p>

          <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 mb-6 text-left" data-id="element-204">
            <p className="text-base md:text-lg text-gray-800 font-medium" data-id="element-205">
              La cocción con aire caliente permite reducir hasta 70-80% del
              aceite comparado con frituras tradicionales.
            </p>
          </div>

          <p className="text-xl font-bold text-gray-900 mb-4" data-id="element-206">
            Esto significa:
          </p>

          <div className="flex flex-col md:flex-row justify-center items-center gap-3 md:gap-6 mb-8 text-lg font-bold text-gray-800" data-id="element-207">
            <span className="flex items-center" data-id="element-208">
              <span className="text-green-500 mr-2" data-id="element-209">✔</span> menos calorías
            </span>
            <span className="flex items-center" data-id="element-210">
              <span className="text-green-500 mr-2" data-id="element-211">✔</span> menos grasas
            </span>
            <span className="flex items-center" data-id="element-212">
              <span className="text-green-500 mr-2" data-id="element-213">✔</span> más facilidad para
              mantener una alimentación saludable
            </span>
          </div>

          <div className="bg-gray-900 text-white rounded-2xl p-6 md:p-8 shadow-2xl mb-8" data-id="element-214">
            <h3 className="text-2xl font-bold mb-5 text-yellow-400" data-id="element-215">
              Cómo funciona el sistema
            </h3>

            <div className="space-y-4 text-lg md:text-xl text-left max-w-md mx-auto font-medium" data-id="element-216">
              <p className="flex items-center" data-id="element-217">
                <span className="text-2xl mr-4" data-id="element-218">📂</span> Abres el material
              </p>
              <p className="flex items-center" data-id="element-219">
                <span className="text-2xl mr-4" data-id="element-220">👀</span> eliges la receta o el
                plan semanal
              </p>
              <p className="flex items-center" data-id="element-221">
                <span className="text-2xl mr-4" data-id="element-222">🍽</span> cocinas en minutos
              </p>
            </div>

            <div className="mt-6 pt-5 border-t border-gray-700 text-base md:text-lg text-gray-300 space-y-1" data-id="element-223">
              <p data-id="element-224">Sin dietas extremas.</p>
              <p data-id="element-225">Sin pasar horas en la cocina.</p>
              <p data-id="element-226">Sin sentir que estás "a dieta".</p>
            </div>
          </div>

          <CTAButton href="#compra" text="🔥 SÍ, QUIERO EMPEZAR A ADELGAZAR HOY" data-id="element-227" />
        </motion.div>
      </div>
    </section>;
}